import type { DataMode } from '../domain/models.js';

export function resolveDataMode(configuredValue: string | undefined): DataMode {
  const normalized = configuredValue?.trim() || 'mock';
  if (normalized === 'mock' || normalized === 'api') return normalized;
  throw new Error(
    `Unsupported VITE_DATA_MODE "${normalized}". Supported modes are "mock" and "api".`,
  );
}
